// BES-9331: The form-component registry. Shared by the dashboard editor, the
// guest signing page (hydration, completeness gate, client PDF serializer),
// and the backend (extraction, finalize validation, server-side PDF fallback).
// Centralizing the completion rules keeps the client completion gate and the
// server finalize check from ever disagreeing (which would show the guest
// "complete" and then reject the submit with a 400), and centralizing the PDF
// markup keeps both PDF paths rendering identically. Adding a future component
// means adding a descriptor here; the marker plumbing is generic.
import { addressInputDescriptor } from './addressInput.js';
import { attachmentUploadDescriptor } from './attachmentUpload.js';
import { emailInputDescriptor } from './emailInput.js';
import { phoneInputDescriptor } from './phoneInput.js';
export const FORM_COMPONENT_REGISTRY = [
    phoneInputDescriptor,
    emailInputDescriptor,
    attachmentUploadDescriptor,
    addressInputDescriptor,
];
export const getFormComponentsForSurface = (surface) => FORM_COMPONENT_REGISTRY.filter((descriptor) => descriptor.surfaces.includes(surface));
export const getFormComponentDescriptor = (type) => FORM_COMPONENT_REGISTRY.find((descriptor) => descriptor.type === type);
/**
 * The single completion gate for registry components. The guest portal calls
 * this inside its canComplete computation and the backend calls it inside
 * finalize with the same value-resolution rule (progress channel = submitted
 * values, upload channel = progress_json.formUploads), so the two can never
 * drift apart.
 */
export const findIncompleteFormComponents = (fields, getValue) => {
    const failures = [];
    for (const field of fields) {
        const descriptor = getFormComponentDescriptor(field.type);
        if (!descriptor)
            continue;
        const value = getValue(field);
        if (descriptor.isComplete(field, value))
            continue;
        failures.push({ field, reason: descriptor.validate(field, value) ?? 'This field is required' });
    }
    return failures;
};
